import { AuthUserService, IAuthUser } from '../services/authusers.service';

class ResetPasswordController implements ng.IComponentController {
    private authUser: IAuthUser;

    constructor(private AuthUserService: AuthUserService, private $state: ng.ui.IStateService) {
        'ngInject';
    }

    public $onInit = () => {
        if(!this.authUser) {
            this.AuthUserService.getCurrentUser().then((user : IAuthUser) => {
                this.authUser = user;
            });
        }
    }

    public resetPassword = () => {
        this.AuthUserService.resetPassword(this.authUser).then((response) => {
           (<any>$('#ResetPasswordModal')).modal('hide');
        });
    }
}

export const resetPasswordComponent : ng.IComponentOptions = {
    bindings: {
        authUser: "<"
    },
    controller : ResetPasswordController,
    template : <string>require('./resetPassword.html')
};



// WEBPACK FOOTER //
// ./src/app/authsettings/components/resetPassword.component.ts